import {FormBuilder, FormGroup} from "@angular/forms";
import {distinctUntilChanged, filter, map} from "rxjs/operators";
import {OrderActions} from "../../../../store/actions/order.actions";
import {Product, StandardName} from "../../../../store/state/order.state";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";
import {UmbrellaValidators} from "../../../../umbrella-common/validation/umbrella-validators";
import {orderSelector} from "../../../../store/state/state.selectors";
import {CLIENT_COUNTRY_CONFIGS} from "../../../../configuration/configs/client-country-configs";

@Injectable()
export class CatastrophicRiskHandler extends BaseFormControlHandler {

	private showIso9001CatastrophicRisk: boolean;

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
		this.store.select(orderSelector)
			.pipe(
				filter(order => order.clientCountry != null),
				map(order => CLIENT_COUNTRY_CONFIGS[order.clientCountry]),
				map(config => config.order.showIso9001CatastrophicRisk)
			).subscribe(show => this.showIso9001CatastrophicRisk = show);
	}

	buildControls(form: FormGroup, product: Product) {
		if (product.standard.name === StandardName.ISO_9001) {
			const control = this.fb.control(product.catastrophicRisk, [UmbrellaValidators.radiobuttonRequired()]);
			form.addControl(`catastrophicRisk${(product.standard.name)}`, control);
			this.addSubscription(product.standard.name, control.valueChanges.pipe(distinctUntilChanged())
				.subscribe((catastrophicRisk: boolean) => {
					this.store.dispatch(OrderActions.SET_CATASTROPHIC_RISK({
						standardName: product.standard.name,
						catastrophicRisk
					}));
				}));
		}
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		if (product.standard.name == StandardName.ISO_9001) {
			product.catastrophicRisk = formService.getValueFor('catastrophicRisk', srcForm);
		}
	}

	override shouldApply(): boolean {
		return this.showIso9001CatastrophicRisk;
	}
}
